import classNames from 'classnames'

import { THEME_NO_IMG_VALUE } from '@apps-common/config/theme'
import { usePortalFirebaseUser } from '@apps-common/hooks/usePortalFirebaseUser'
import { useTheme } from '@apps-common/hooks/useTheme'
import { RadionetLogo } from '../logos'

interface IProps {
  classes?: string
}

export const CompanyProfileImagePlaceholder: React.FC<IProps> = ({ classes }) => {
  const user = usePortalFirebaseUser()
  const { getLogoUrl } = useTheme()

  const logoPrimary = getLogoUrl('primary')
  const logoSecondary = getLogoUrl('secondary')

  if (logoSecondary && logoSecondary?.length > 0 && logoSecondary !== THEME_NO_IMG_VALUE) {
    return <img src={logoSecondary} className={classNames('max-h-[45%] sm:max-h-[45%]', classes)} alt='Secondary company logo' />
  }

  if (logoPrimary && logoPrimary?.length > 0 && logoPrimary !== THEME_NO_IMG_VALUE) {
    return <img src={logoPrimary} className={classNames('max-h-[45%] sm:max-h-[45%]', classes)} alt='Primary company logo' />
  }

  return (
    <div className={classNames(classes, 'bg-logo-background flex items-center justify-center')}>
      {user?.isRadionetUser && <RadionetLogo color='fill-text' classes='w-[200px] h-[50px]' />}
      {!user?.isRadionetUser && (
        <span className='text-[0.8rem] leading-[0.9rem] jost-bold bg-surface-2 rounded-lg px-3 text-text-muted py-2 uppercase'>
          no logo
          <br />
          provided
        </span>
      )}
    </div>
  )
}
